// @flow
import { connect } from 'react-redux';

import BackendSidebarLink from '../BackendSidebarLink';

import * as selectors from '../../../reducers';


const BackendSidebarEventsLink = connect(
  state => ({
    badgeCount: selectors.getChangeStopRequestPendingCounter(state),
  }),
)(BackendSidebarLink);


export default BackendSidebarEventsLink;



// WEBPACK FOOTER //
// ./src/scripts/components/BackendSidebar/BackendSidebarEventsLink/index.jsx